var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContextPadPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ContextPadPlus_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h13v13H0z",
  style: {
    mixBlendMode: "multiply"
  },
  transform: "translate(.5 .241)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0094FF",
  d: "M7 .241a6.58 6.58 0 0 0-6.5 6.5 6.58 6.58 0 0 0 6.5 6.5 6.58 6.58 0 0 0 6.5-6.5A6.58 6.58 0 0 0 7 .241m3.714 6.965h-3.25v3.25h-.928v-3.25h-3.25v-.93h3.25v-3.25h.928v3.25h3.25z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ContextPadPlus_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5.241h13v13H.5z"
})))));
export default SvgContextPadPlus;